import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const VerifiedBadge = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M15.5545 7.23853C16.4751 5.08716 19.5249 5.08716 20.4455 7.23853C21.014 8.56697 22.539 9.19865 23.8803 8.66126C26.0525 7.79097 28.209 9.94751 27.3387 12.1197C26.8013 13.461 27.433 14.986 28.7615 15.5545C30.9128 16.4751 30.9128 19.5249 28.7615 20.4455C27.433 21.014 26.8013 22.539 27.3387 23.8803C28.209 26.0525 26.0525 28.209 23.8803 27.3387C22.539 26.8013 21.014 27.433 20.4455 28.7615C19.5249 30.9128 16.4751 30.9128 15.5545 28.7615C14.986 27.433 13.461 26.8013 12.1197 27.3387C9.94751 28.209 7.79097 26.0525 8.66126 23.8803C9.19865 22.539 8.56697 21.014 7.23853 20.4455C5.08716 19.5249 5.08716 16.4751 7.23853 15.5545C8.56697 14.986 9.19865 13.461 8.66126 12.1197C7.79097 9.94751 9.94751 7.79097 12.1197 8.66126C13.461 9.19865 14.986 8.56697 15.5545 7.23853Z" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M14.625 18L17.6033 20.8125L21.9375 14.6249" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper strokeWidth={1} {...props} variant="outline" viewBox="0 0 36 36">{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { VerifiedBadge };